import stockAPI from "@/api/stock";

const getStockWithoutPagination = async (context, token) => {
  const response = await stockAPI.getStockWithoutPagination(token);
  if (response.status) {
    context.commit("setStockWithoutPagination", response.data);
  }
  return response;
};

const getStocks = async (context, data) => {
  const response = await stockAPI.getStocks(data.token, data.page);
  if (response.status) {
    context.commit("setStocks", response.data);
  }
  return response;
};

let actions = {
  getStockWithoutPagination,
  getStocks
};

export default actions;
